module.exports = __webpack_public_path__ + "static/fastest-implementation-fall-1faf8e5c5c314847c7ffb62a10620c7b.svg";